var moduleMap = {
	"./RosterGroupsHatch": () => {
		return Promise.all(/* __federation_expose_RosterGroupsHatch */[__webpack_require__.e(289), __webpack_require__.e(477), __webpack_require__.e(960), __webpack_require__.e(60), __webpack_require__.e(296), __webpack_require__.e(421)]).then(() => (() => ((__webpack_require__(71153)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});